(() => {
  if (customElements.get('infinote-pdp-story')) return;
  customElements.define('infinote-pdp-story', class extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('[data-ip-track]');
      if (!track) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const previous = this.querySelector('[data-ip-previous]');
      const next = this.querySelector('[data-ip-next]');
      const progress = this.querySelector('[data-ip-progress]');
      const update = () => {
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        previous.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= maximum - 1;
        if (progress) progress.style.width = `${maximum ? 20 + 80 * Math.min(1, Math.max(0, track.scrollLeft / maximum)) : 100}%`;
      };
      const move = direction => track.scrollBy({
        left: direction * (track.querySelector('li')?.getBoundingClientRect().width || track.clientWidth),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
      previous.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      track.addEventListener('scroll', update, { ...options, passive: true });
      track.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        move(event.key === 'ArrowLeft' ? -1 : 1);
      }, options);
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
})();
